export function isValidEquipmentCoordinate(point) {
  if (!point || point.lat == null || point.lng == null) {
    return false;
  }

  const lat = Number(point.lat);
  const lng = Number(point.lng);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return false;
  }

  if (Math.abs(lat) < 0.000001 && Math.abs(lng) < 0.000001) {
    return false;
  }

  return Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
}

export function getEquipmentPathPoints(equipment) {
  if (!equipment) return [];
  if (Array.isArray(equipment.last_posi_point)) {
    return equipment.last_posi_point.filter((point) =>
      isValidEquipmentCoordinate(point)
    );
  }
  if (isValidEquipmentCoordinate(equipment.last_posi_point)) {
    return [equipment.last_posi_point];
  }
  return [];
}

export function getFarmMapCenter(farm) {
  const source = farm || {};
  const centroid = source.centroid || {};
  let lat = Number(centroid.lat);
  let lng = Number(centroid.lng);

  if (
    !Number.isFinite(lat) ||
    !Number.isFinite(lng) ||
    (lat === 0 && lng === 0)
  ) {
    lat = Number(source.latitude);
    lng = Number(source.longitude);
  }

  if (
    !Number.isFinite(lat) ||
    !Number.isFinite(lng) ||
    (lat === 0 && lng === 0)
  ) {
    const geo = source.geo_coords;
    if (Array.isArray(geo) && geo.length >= 2) {
      lat = Number(geo[1]);
      lng = Number(geo[0]);
    } else if (geo && typeof geo === "object") {
      lat = Number(geo.lat != null ? geo.lat : geo.y);
      lng = Number(geo.lng != null ? geo.lng : geo.x);
    }
  }

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return { lat: -15.78, lng: -47.93 };
  }

  return { lat, lng };
}

export function spreadFallbackPosition(center, index, total) {
  const safeCenter = center || { lat: -15.78, lng: -47.93 };
  const radiusDeg = 0.0018;
  const angle = (2 * Math.PI * index) / Math.max(total, 1);
  return {
    lat: safeCenter.lat + radiusDeg * Math.sin(angle),
    lng: safeCenter.lng + radiusDeg * Math.cos(angle),
  };
}

export function resolveEquipmentMarkerPosition(equipment, farm, index, total) {
  const pathPoints = getEquipmentPathPoints(equipment);
  if (pathPoints.length > 0) {
    return {
      position: pathPoints[pathPoints.length - 1],
      isFallback: false,
    };
  }

  return {
    position: spreadFallbackPosition(getFarmMapCenter(farm), index, total),
    isFallback: true,
  };
}

export function countEquipmentWithMapPosition(equipments, farm) {
  const list = Object.values(equipments || {});
  return list.reduce((total, equipment, index) => {
    const resolved = resolveEquipmentMarkerPosition(
      equipment,
      farm,
      index,
      list.length
    );
    return total + (resolved.position ? 1 : 0);
  }, 0);
}
